/*
 * @Author: gongzhichao 18311120024@163.com
 * @Date: 2023-05-25 19:05:44
 * @LastEditors: gongzhichao 18311120024@163.com
 * @LastEditTime: 2024-04-29 11:04:35
 * @FilePath: \jyrg-web\src\request\request.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/**
 * @Author: gongzhichao
 * @Date: 2023
 * @Description: 请求文件
 */

import axios from "axios";
import config from "../config";

const baseURL = config.baseUrl[process.env.NODE_ENV];
// const baseURL = config.baseUrl["development"];
const service = axios.create({ baseURL, timeout: 15000 });

service.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    console.log(error);
    Promise.reject(error);
  }
);

service.interceptors.response.use(
  (response) => {
    const res = response.data;
    if (
      response.status === 401 ||
      res.code === 20002 ||
      res.code === 401 ||
      res.code === 5000 ||
      res.code > 50000
    ) {
      return Promise.reject("error");
    } else {
      return response.data;
    }
  },
  (error) => {
    console.log("err" + error);
    return Promise.reject(error);
  }
);

export default service;
